var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocateAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8199 8.04795L15.6527 7.19269V5.13885L14.2705 5.139V6.18052L12.6397 4.98537C12.3166 4.74857 11.8767 4.75189 11.5572 4.99346L7.49369 8.06457C7.19739 8.28838 7.14411 8.71463 7.38019 9.00514C7.6053 9.28194 8.0151 9.3202 8.29969 9.10506L8.56783 8.90233V12.3246C8.56783 12.7651 8.92492 13.1225 9.36575 13.1225H14.9648C15.4054 13.1225 15.7627 12.7654 15.7627 12.3246V8.90477L16.0561 9.11991C16.1732 9.20597 16.3097 9.24741 16.4446 9.24741C16.6441 9.24741 16.8408 9.15688 16.9699 8.98606C17.1909 8.69294 17.1163 8.26539 16.82 8.04793L16.8199 8.04795ZM11.1673 11.8638V8.84354H13.1626V11.8638H11.1673Z",
    fill: "#0EA5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.165 1.60005C8.10335 1.60005 4.7998 4.90437 4.7998 8.96528C4.7998 12.4668 7.27386 15.4881 10.6957 16.183L11.6618 18.6172C11.7748 18.828 11.9908 18.9574 12.2289 18.9574H12.244C12.4879 18.9516 12.705 18.8116 12.8166 18.5751L13.6627 16.1774C17.0688 15.4716 19.5312 12.4536 19.5312 8.96521C19.5304 4.90426 16.2265 1.59998 12.1649 1.59998L12.165 1.60005ZM12.165 2.75475C15.5896 2.75475 18.3759 5.54083 18.3759 8.96595C18.3759 12.3908 15.5898 15.1768 12.165 15.1768C8.74029 15.1768 5.95385 12.3907 5.95385 8.96558C5.95385 5.54072 8.74036 2.75475 12.165 2.75475Z",
    fill: "#0EA5E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0445 20.6197C18.0445 20.0785 15.4124 19.64 12.1649 19.64H12.1623C8.91661 19.6402 6.28564 20.0789 6.28564 20.62C6.28564 21.1612 8.9178 21.6 12.1653 21.6C15.4127 21.6 18.0445 21.1607 18.0445 20.6197Z",
    fill: "#0EA5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateAsset);
export default __webpack_public_path__ + "static/media/LocateAsset.b49af886ef14265a2f66264f58fac084.svg";
export { ForwardRef as ReactComponent };